import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';
import type { App } from 'vue';

export default async (Vue: App<Element>) => {
  try {
    const tm = new Thumbmark({ logging: false });
    const { thumbmark } = await tm.get();
    const value = thumbmark ? `v2:${thumbmark}` : '';

    //@ts-expect-error ошибки нет
    window.AffCtrlUserId = value;
    Vue.config.globalProperties.$api.affiliatesApi.defaults.headers.common['X-User-Id'] = value;
    Vue.config.globalProperties.$api.miscApi.defaults.headers.common['X-User-Id'] = value;
  } catch (error) {
    window.console.error(error);
  }
};
